import { VtoConfiguration } from "@hermes/api-model-vto";

import { VTO_CONFIGURATION_UNDEFINED } from "../constants/vto.constant";

export enum VtoModalStatus {
    "NONE" = "NONE",
    "MODAL_OPENED" = "MODAL_OPENED",
    "MODAL_CLOSED" = "MODAL_CLOSED",
    "CAMERA_LOADING" = "CAMERA_LOADING",
    "CAMERA_LOADED" = "CAMERA_LOADED",
    "ON_ERROR" = "ON_ERROR",
}

export enum VtoSdkError {
    "NO_ERROR" = "NO_ERROR",
    "ERROR_CAMERA" = "ERROR_CAMERA",
    "ERROR_RESOLUTION" = "ERROR_RESOLUTION",
    "ERROR_TIMEOUT" = "ERROR_TIMEOUT",
}

export type CurrentVtoSku = "NO_SELECT" | "NO_SHADE" | string;

export type VtoConfigurationUndefined = typeof VTO_CONFIGURATION_UNDEFINED;
export type VtoConfigurationState =
    | VtoConfigurationUndefined
    | VtoConfiguration;
